import { Sidebar, Menu, MenuItem, SubMenu } from "react-pro-sidebar";

import SidebarHeader from "./SidebarHeader";
import { isActiveLink } from "../../../utils/linkActiveChecker";

import { useNavigate } from "react-router-dom";
import { isServicesListPath, navigateFullPage } from "@/utils/fullPageNavigation";
import { useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { User } from "@/types/userTypes";
import { logoutUser } from "@/features/user/userSlice";

const links = {
  worker: [
    {
      routePath: "/dashboard",
      name: "Panel del profesional",
    },
    {
      routePath: "/servicios",
      name: "Servicios",
    },
    {
      routePath: "/",
      name: "Logout",
    },
  ],
  user: [
    {
      routePath: "/servicios",
      name: "Servicios",
    },
    {
      routePath: "/dashboard",
      name: "Dashboard",
    },
    {
      routePath: "/",
      name: "Logout",
    },
  ],
  default: [
    {
      routePath: "/servicios",
      name: "Servicios",
    },
    {
      routePath: "/servicios",
      name: "Ingresar",
    },
  ],
};

const menuItemStyle = {
  fontSize: 30,
  fontWeight: 700,
  color: "black",
  height: "40px",
  lineHeight: "40px",
};
const subMenuItemStyle = {
  fontSize: 20,
  fontWeight: 700,
  color: "black",
  padding: 0,
};

const Index = () => {
  const dispatch = useDispatch();
  const { user: me }: { user: User } = useSelector(
    (state: { user }) => state.user
  );

  const { pathname } = useLocation();
  const navigate = useNavigate();

  return (
    <div
      className="offcanvas offcanvas-start mobile_menu-contnet"
      tabIndex={-1}
      id="offcanvasMenu"
      data-bs-scroll="true"
    >
      <SidebarHeader />

      <Sidebar>
        <Menu>
          {links[me.type ? me.type : "default"]?.map((menuItem, i) =>
            menuItem.name === "Servicios" ? (
              <SubMenu label={<p style={menuItemStyle}>Servicios</p>} key={i}>
                <MenuItem>
                  <a href="/servicios" style={subMenuItemStyle}>
                    Todos los servicios
                  </a>
                </MenuItem>
                <MenuItem>
                  <a
                    href="/servicios?filter=Limpieza"
                    style={subMenuItemStyle}
                  >
                    Limpieza
                  </a>
                </MenuItem>
                <MenuItem>
                  <a
                    href="/servicios?filter=Mudanza"
                    style={subMenuItemStyle}
                  >
                    Mudanza
                  </a>
                </MenuItem>
                <MenuItem>
                  <a
                    href="/servicios?filter=Jardiner%C3%ADa"
                    style={subMenuItemStyle}
                  >
                    Jardinería
                  </a>
                </MenuItem>
                <MenuItem>
                  <a
                    href="/servicios?filter=Electricidad"
                    style={subMenuItemStyle}
                  >
                    Electricidad
                  </a>
                </MenuItem>
                <MenuItem>
                  <a
                    href="/servicios?filter=Agua%20y%20Gas"
                    style={subMenuItemStyle}
                  >
                    Agua y Gas
                  </a>
                </MenuItem>
                <MenuItem>
                  <a
                    href="/servicios?filter=Env%C3%ADos"
                    style={subMenuItemStyle}
                  >
                    Envíos
                  </a>
                </MenuItem>
                <MenuItem>
                  <a
                    href="/servicios?filter=Handyman"
                    style={subMenuItemStyle}
                  >
                    Handyman
                  </a>
                </MenuItem>
              </SubMenu>
            ) : (
              <MenuItem
                onClick={() => {
                  if (menuItem.name !== "Ingresar" && menuItem.name !== "Logout") {
                    if (isServicesListPath(menuItem.routePath)) {
                      navigateFullPage(menuItem.routePath);
                    } else {
                      navigate(menuItem.routePath);
                    }
                  }
                  menuItem.name === "Logout" && dispatch(logoutUser());
                }}
                className={
                  isActiveLink(menuItem.routePath, pathname) &&
                  menuItem.name !== "Logout"
                    ? "menu-active-link"
                    : ""
                }
                key={i}
              >
                {menuItem.name === "Ingresar" ? (
                  <a
                   href="javascript:void(0)"
                    className="call-modal"
                    data-bs-toggle="modal"
                    data-bs-target="#loginPopupModal"
                    style={menuItemStyle}
                  >
                    Ingresar
                  </a>
                ) : (
                  <p style={menuItemStyle}>{menuItem.name}</p>
                )}
              </MenuItem>
            )
          )}
        </Menu>
      </Sidebar>

      {/* <SidebarFooter /> */}
    </div>
  );
};

export default Index;
